import { TFunction } from "i18next";
import { User } from "./User";
import { ApplicationFormatter } from "../applications/ApplicationProvider";
import { MUIDataTableColumn } from "mui-datatables";
import PersonIcon from "@mui/icons-material/Person";
import { YesNoField } from "../../shared/components/forms/YesNoField";
import { filterAccountServiceRoles } from "./ApplicationRoles";
import React from "react";
import { MRT_ColumnDef } from "material-react-table";

export function usersTableColumns(t: TFunction,
                                  smallScreens: boolean,
                                  applicationFormatter: ApplicationFormatter,
                                  account?: User): MUIDataTableColumn[] {
  return [
    {
      name: 'id', label: '', options: {
        customHeadLabelRender: () => null,
        customBodyRender: (value) => (
          value === account?.id ? <PersonIcon /> : ''
        ),
        filter: false,
        viewColumns: false,
        display: !smallScreens
      }
    },
    {name: 'firstName', label: t('User.firstName'), options: {filter: false}},
    {name: 'lastName', label: t('User.lastName'), options: {filter: false}},
    {name: 'email', label: t('User.email'), options: {filter: false}},
    {
      name: 'applicationRoles',
      label: t('User.role'),
      options: {
        customBodyRender: (value) => (
          <ul style={ {margin: 'unset'} }>
            {
              filterAccountServiceRoles(value as any)
                .map(appRole => applicationFormatter.formatApplicationRole(appRole))
                .map(appRole => (<li key={ appRole }>{ appRole }</li>))
            }
          </ul>),
        filter: false,
        sort: false,
        display: !smallScreens
      }
    },
    {
      name: 'company',
      label: t('Company.titleEdit'),
      options: {
        customBodyRender: (company) => (
          company ? <p style={ {margin: 'unset'} }>{ company.name }</p> : <p />
        ),
        filter: false,
        display: !smallScreens
      }
    }
  ];
}

export function usersTableColumnsMRT(t: TFunction,
                                     applicationFormatter: ApplicationFormatter,
                                     account?: User): MRT_ColumnDef<User>[] {
  return [
    {
      accessorKey: 'id',
      header: '',
      Cell: ({row}) => (row.original.id === account?.id ? <PersonIcon /> : ''),
      enableColumnFilter: false,
    },
    {accessorKey: 'firstName', header: t('User.firstName'), enableColumnFilter: false},
    {accessorKey: 'lastName', header: t('User.lastName'), enableColumnFilter: false},
    {accessorKey: 'email', header: t('User.email'), enableColumnFilter: false},
    {
      accessorKey: 'enabled',
      header: t('User.enabled'),
      Cell: ({row}) => <YesNoField value={ row.original.enabled } />,
      enableColumnFilter: false,
    },
    {
      accessorKey: 'emailVerified',
      header: t('User.emailVerified'),
      Cell: ({row}) => <YesNoField value={ row.original.emailVerified } />,
      enableColumnFilter: false,
    },
    {
      id: 'applicationRoles',
      header: t('User.applicationRoles.application') + "/" + t('User.applicationRoles.role'),
      enableColumnFilter: false,
      Cell: ({row}) => (
        <ul style={ {margin: 'unset'} }>
          {
            filterAccountServiceRoles(row.original.applicationRoles)
              .map(appRole => applicationFormatter.formatApplicationRole(appRole))
              .map(appRole => (<li key={ appRole }>{ appRole }</li>))
          }
        </ul>),
    },
    {
      id: 'company',
      header: t('User.company'),
      accessorFn: (row) => row.company ? row.company.name : '',
      enableColumnFilter: false,
    }
  ];
}
